import { Flex, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { useField } from "formik";
import { FunctionComponent } from "react";
import { EmojiInput, EmojiInputProps } from "../EmojiInput";

type Props = Omit<EmojiInputProps, "onChange" | "value"> & {
  name: string;
};

export const FormikEmojiInput: FunctionComponent<Props> = (props) => {
  const { name, ...emojiInputProps } = props;

  const [{ value }, { error, touched }, { setTouched, setValue }] =
    useField(name);

  return (
    <Flex direction="column" onBlur={() => !touched && setTouched(true)}>
      <FormControl isInvalid={touched && !!error}>
        <EmojiInput
          value={value}
          onChange={setValue}
          disabled={touched && !!error}
          name={name}
          {...emojiInputProps}
        />
        {touched && error && <FormErrorMessage>{error}</FormErrorMessage>}
      </FormControl>
    </Flex>
  );
};
